module.exports = __webpack_public_path__ + "static/media/olympus.53796f25.gif";